import React, { useMemo } from 'react';
import BaseSelect from './BaseSelect';

// 국가 전화 코드를 선택하도록 구성한 래퍼 셀렉트
export default function PhoneCodeSelect({
  value,
  onChange,
  options = [], // [{ alpha2, name, dial }]
  className = '',
  placeholder = '국가번호',
  disabled = false,
}) {
  const opts = useMemo(
    () =>
      options.map((o) => ({
        label: `${o.name} (${o.dial})`,
        value: o.dial,
        key: o.alpha2,
      })),
    [options]
  );

  return (
    <BaseSelect
      options={opts}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      ariaLabel="국가번호 선택"
      variant="phonecode"
    />
  );
}
